import { render, staticRenderFns } from "./ForgotPasswordCDEA.vue?vue&type=template&id=2a84702a"
import script from "./ForgotPasswordCDEA.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCDEA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports